export const languages = {
  en: 'English',
  de: 'Deutsch',
  ru: 'Русский',
  es: 'Español',
  it: 'Italiano',
  hi: 'हिन्दी',
  zh: '汉语',
  fr: 'Français',
  mn: 'Монгол хэл',
}

export const langDefault = 'en'

export const appWalletGoogle = ''
export const appWalletApple = ''
export const appFarmGoogle = ''
export const appFarmApple = ''

// const normalizeUrl = (url) => {
//   const schema = window.location.protocol || '//'
//   if (!url) return ''
//   const _url = url[url.length - 1] === '/' ? url : url + '/'
//   return _url.includes('://') ? _url : schema + '//' + _url
// }

export const usedPacks = [
  'su_farm_light_1',
  'su_farm_air_1',
  'su_farm_starter_1',
  'su_farm_basic_1',
  'su_farm_medium_1',
  'su_farm_plus_1',
  'su_farm_pro_1',
  'su_farm_premium_1',
  'su_farm_exclusive_1',
  'su_farm_diamond_1',
  'su_farm_ultima_1',
  'su_farm_smart_ultima_1',
]

export const cdnDomain = 'https://ultimafarm.com/'
// export const blogDomain = 'https://blog.platincoin.com/'

export const breakpoints = {
  phone: 0,
  tablet: 768,
  desktop: 1200,
}
